import { useEffect, useState } from "react";
import { Control, FieldErrors, UseFormRegister } from "react-hook-form";
import { ContatoTypes } from "../types";
import InputMask from "react-input-mask";

import '../styles/styles.css';
import { useGetAllClientes } from "../../Clientes/hooks/useGetClientes";
import { LoadingPage } from "../../../shared/components/LoadingPage";
import { AutoComplete } from "../../../shared/components/Inputs/AutoComplete";

interface FormModalTypes {
  register: UseFormRegister<any>;
  control: Control<any>;
  contato?: ContatoTypes;
  disabled?: boolean;
  errors?: FieldErrors<any>;
  formEdit?: boolean;
}

interface ClienteOption {
  value: string;
  label: string
}

export function FormModalContato({
  register,
  control,
  contato,
  disabled,
  errors,
  formEdit }: FormModalTypes) {
    const [clienteOptions, setClienteOptions] = useState<ClienteOption[]>([]);

  const { data: clienteData, isLoading } = useGetAllClientes();

  useEffect(() => {
    if (clienteData) {
      const options = clienteData.map((c: any) => ({
        value: c.Id.toString(),
        label: c.Nome,
      }));
      setClienteOptions(options);
    }
  }, [clienteData]);

  return (
    <form className="w-[70rem]">
      {clienteOptions.length === 0 ? <div className="h-[30rem] flex items-center justify-center"><LoadingPage /></div> :
        <>
          <div className="flex justify-center items-center gap-3 w-[100%]">
            <label>
              Nome<span className="text-error">*</span>
              <input
                type="text"
                {...register("Nome", { required: !contato?.Nome ? true : false })}
                name="Nome"
                disabled={disabled}
                maxLength={50}
                className={`input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] ${errors?.Nome && 'focus:outline-none focus:ring-2 focus:ring-error'}`} />
            </label>
            <label>
              Sobrenome<span className="text-error">*</span>
              <input
                type="text"
                {...register("Sobrenome", { required: !contato?.Sobrenome ? true : false })}
                name="Sobrenome"
                disabled={disabled}
                maxLength={50}
                className={`input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3] ${errors?.Sobrenome && 'focus:outline-none focus:ring-2 focus:ring-error'}`} />
            </label>
            <label>
              E-mail
              <input
                type="email"
                {...register("Email")}
                name="Email"
                disabled={disabled}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
          </div>
          <div className="flex gap-3 justify-center items-center">
            <label>
              Telefone do Escritório
              {!formEdit
                ? <InputMask mask="(99) 9999-9999"
                  type="text"
                  {...register("TelefoneEscritorio")}
                  name="TelefoneEscritorio"
                  className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
                :
                <input
                  type="text"
                  {...register("TelefoneEscritorio")}
                  name="TelefoneEscritorio"
                  disabled={disabled}
                  className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
              }
            </label>
            <label>
              Telefone do Celular
              {!formEdit
                ? <InputMask mask="(99) 99999-9999"
                  type="text"
                  {...register("TelefoneCelular")}
                  name="TelefoneCelular"
                  className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
                :
                <input
                  type="text"
                  {...register("TelefoneCelular")}
                  name="TelefoneCelular"
                  disabled={disabled}
                  className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
              }
            </label>
            <label>
              Telefone com Whatsapp
              {
                !formEdit
                  ?
                  <InputMask mask="(99) 99999-9999"
                    type="text"
                    {...register("TelefoneWhatsapp")}
                    name="TelefoneWhatsapp"
                    className="input-login-style w-[11rem] mb-5" />
                  :
                  <input
                    type="text"
                    {...register("TelefoneWhatsapp")}
                    name="TelefoneWhatsapp"
                    disabled={disabled}
                    className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
              }
            </label>
            <label>
              Codigo ABS
              <input
                type="text"
                {...register("CodigoABS")}
                name="CodigoABS"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Código Campo
              <input
                type="text"
                {...register("CodigoCampo")}
                name="CodigoCampo"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Cargo
              <input
                type="text"
                {...register("Cargo")}
                name="Cargo"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[11rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
          </div>
          <div className="flex gap-3 items-center">
            <label htmlFor="ClienteNome" className="h-[5.13rem]">
              Cliente
              {!isLoading && 
                <AutoComplete 
                  dataOptions={clienteOptions}
                  disabled={disabled}
                  control={control}
                  dataName="ClienteId"
                />
              }

            </label>
            <label>
              Nome do Vendedor
              <input
                type="text"
                {...register("VendedorProgenieNome")}
                name="VendedorProgenieNome"
                disabled={disabled}
                maxLength={100}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              CEP
              {!formEdit
                ? <InputMask mask="99999-999"
                  type="text"
                  {...register("EnderecoPrincipalCEP")}
                  name="EnderecoPrincipalCEP"
                  className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
                :
                <input
                  type="text"
                  {...register("EnderecoPrincipalCEP")}
                  name="EnderecoPrincipalCEP"
                  disabled={disabled}
                  className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
              }
            </label>
          </div>
          <div className="flex gap-3 justify-center items-center">
            <label>
              Logradouro
              <input
                type="text"
                {...register("EnderecoPrincipalLogradouro")}
                name="EnderecoPrincipalLogradouro"
                disabled={disabled}
                maxLength={100}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Cidade
              <input
                type="text"
                {...register("EnderecoPrincipalCidade")}
                name="EnderecoPrincipalCidade"
                disabled={disabled}
                maxLength={100}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Estado
              <input
                type="text"
                {...register("EnderecoPrincipalEstado")}
                name="EnderecoPrincipalEstado"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Pais
              <input
                type="text"
                {...register("EnderecoPrincipalPais")}
                name="EnderecoPrincipalPais"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[14rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
          </div>
          <div className="flex gap-3 items-center">
            <label>
              CEP Alternativo
              {!formEdit
                ? <InputMask mask="99999-999"
                  type="text"
                  {...register("EnderecoAlternativoCEP")}
                  name="EnderecoAlternativoCEP"
                  className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
                :
                <input
                  type="text"
                  {...register("EnderecoAlternativoCEP")}
                  name="EnderecoAlternativoCEP"
                  disabled={disabled}
                  className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
              }
            </label>
            <label>
              Logradouro Alternativo
              <input
                type="text"
                {...register("EnderecoAlternativoLogradouro")}
                name="EnderecoAlternativoLogradouro"
                disabled={disabled}
                maxLength={100}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-[#B6B5B6] disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Cidade Alternativa
              <input
                type="text"
                {...register("EnderecoAlternativoCidade")}
                name="EnderecoAlternativoCidade"
                disabled={disabled}
                maxLength={100}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-gray-6 disabled:bg-[#F3F3F3]" />
            </label>
          </div>
          <div className="flex gap-3 items-center">
            <label>
              Estado Alternativo
              <input
                type="text"
                {...register("EnderecoAlternativoEstado")}
                name="EnderecoAlternativoEstado"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[8rem] mb-5 disabled:text-gray-6 disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Pais Alternativo
              <input
                type="text"
                {...register("EnderecoAlternativoPais")}
                name="EnderecoAlternativoPais"
                disabled={disabled}
                maxLength={50}
                className="input-login-style w-[14rem] mb-5 disabled:text-gray-6 disabled:bg-[#F3F3F3]" />
            </label>
            <label>
              Observações
              <input
                type="text"
                {...register("Observacoes")}
                name="Observacoes"
                disabled={disabled}
                className="input-login-style w-[22.8rem] mb-5 disabled:text-gray-6 disabled:bg-[#F3F3F3]" />
            </label>
          </div>
          <span className="text-error">Campos com * são obrigatórios</span>
        </>
      }
    </form>
  );
}
